/**
 * author: lingyb@jpush.cn
 */
export * from './modal.module';
